module.exports = __webpack_public_path__ + "img/rmd-icons.b0e1a5f1.svg";